import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const pcrMasterMixCalculatorTool: Tool = {
  id: "pcr-master-mix-calculator",
  name: () => m.pcr_tool_name(),
  description: () => m.pcr_tool_description(),
  icon: "🧬",
  basePath: "/pcr-master-mix-calculator",
  status: "stable",
  tags: [
    "science",
    "lab",
    "pcr",
    "molecular-biology",
    "pcr-master-mix-calculator",
  ],
};
